<script>
import { VPagination } from 'vuetify/lib';

export default {
  name: 'TablePagination',
  extends: VPagination,
};
</script>

<style lang="scss">
.v-pagination.theme--light {
  background-color: $color-white;
  border-radius: $border-radius-large;
  box-shadow: $shadow-dropdown, $shadow-default;
  color: $color-normal;
  padding: 12px 0;
  width: auto;

  .v-pagination__item,
  .v-pagination__more,
  .v-pagination__navigation {
    border-radius: $border-radius-large;
    box-shadow: none;
    color: $color-normal;
    font-size: $font-size-small;
    font-weight: bold;
    height: 24px;
    margin: 0 2px;
    min-width: 24px;
    outline: none;
    padding: 0 4px;
    transition: background-color 250ms ease, box-shadow 250ms ease, color 100ms ease;
    width: auto;
  }

  .v-pagination__item {
    &:focus {
      box-shadow: $shadow-focus-outline;
    }
  }

  .v-pagination__item:hover {
    background-color: rgba($color-accent, 0.1);
  }

  .v-pagination__item--active,
  .v-pagination__item--active:hover {
    background-color: $color-accent;
    color: $color-white;
  }

  li:first-child {
    margin-right: 24px;
  }

  li:last-child {
    margin-left: 24px;
  }

  .v-pagination__navigation {
    .v-icon {
      color: inherit;
      font-size: 24px;
    }

    &:focus,
    &:hover {
      color: $color-accent;
    }

    &--disabled {
      color: $color-normal-pale;
      opacity: 0.5;
    }
  }

  .mdi-chevron-left:lang(fr)::after {
    content: 'Précédent';
  }
  .mdi-chevron-left:lang(en)::after {
    content: 'Previous';
  }

  .mdi-chevron-right:lang(fr)::after {
    content: 'Suivant';
  }
  .mdi-chevron-right:lang(en)::after {
    content: 'Next';
  }

  .mdi-chevron {
    &-left::after {
      font-family: $font-families;
      font-size: 14px;
      font-style: normal;
      font-weight: bold;
    }

    &-right {
      flex-direction: row-reverse;
    }

    &-right::after {
      font-family: $font-families;
      font-size: 14px;
      font-style: normal;
      font-weight: bold;
    }
  }

  @media screen and (max-width: 468px) {
    .v-icon::after {
      display: none;
    }
  }
}
</style>
